import { InputMask } from 'primeng/inputmask';

/**
 * PrimeNG 20: `InputMask.onInputBlur` шлёт значение в форму, если оно «не равно» прежнему по `!=`, а пустое поле
 * сравнивается как `null != ''`. Фокус и уход из пустого поля с маской (телефоны, паспорта) делают форму изменённой
 * без правки: «Есть несохранённые изменения» и вопрос при уходе (Д-13). Пустое и `null` считаем одним значением.
 */
const proto = InputMask.prototype as unknown as {
  value: unknown;
  unmask: boolean;
  getUnmaskedValue(): string;
  updateModel(e: Event): void;
};
const updateModel = proto.updateModel;

proto.updateModel = function (e: Event) {
  const next = this.unmask ? this.getUnmaskedValue() : (e.target as HTMLInputElement | null)?.value;
  if ((next ?? '') === (this.value ?? '')) return;
  updateModel.call(this, e);
};
